<template>
  <div>
    <div style="position: absolute;right: 22px;top: 55px;z-index: 9">
      <router-link :to="{path:'/overview-setting'}" target="_blank">
        <div class="listIcon pointer">
          <img src="../../assets/images/comprehensive/edit.png">
        </div>
      </router-link>
    </div>

    <div style="width: 100%;height: 90vh;position: relative;" v-if="deviceCustomLayouts.length > 0">
      <vue-drag-resize :h="item.paramsData.position.height"
                       :isDraggable="false"
                       :isResizable="false"
                       :key="item.id"
                       :parentH="winHeight"
                       :parentW="winWidth "
                       :w="item.paramsData.position.width"
                       :x="item.paramsData.position.left"
                       :y="item.paramsData.position.top"
                       v-for="item in deviceCustomLayouts">

        <clouded-glass class="main">
          <div slot="content" style="height: 100%">
            <!--测点值展示-->
            <point-view-drag :layoutData="item"
                             :showButton="false"
                             ref="pointViewDrag"
                             v-if="item.component === 'pointViewDrag' && item.paramsData.formData.length > 0"></point-view-drag>
            <!--内景图-->
            <indoor-setting :space-id="currentSpaceInfo.id" indoorType="list" style="padding: 20px 10px 0 10px;"
                            v-if="item.component === 'indoor'"/>
            <!--实验室情况-->
            <space-device-total :current-space-info="currentSpaceInfo"
                                v-if="item.component === 'deviceTotal'"></space-device-total>
          </div>
        </clouded-glass>


      </vue-drag-resize>
    </div>

  </div>
</template>

<script>
import VueDragResize from 'vue-drag-resize';
import pointViewDrag from "@/views/overview/dialogContent/pointViewDrag";
import SpaceDeviceTotal from "@/views/overview/dialogContent/SpaceDeviceTotal";
import CloudedGlass from "@/components/style/CloudedGlass";
import IndoorSetting from "@/components/indoor_setting/IndoorSetting";

export default {
  name: "ConfigurationListView",
  props: ['currentSpaceInfo', 'deviceCustomLayouts'],
  inject: ['overflow'],
  components: {VueDragResize, pointViewDrag, SpaceDeviceTotal, CloudedGlass, IndoorSetting},
  data() {
    return {
      winWidth: 0,
      winHeight: 0,
    }
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getPointData:5000': this.getPointData})
  },
  destroyed() {
    window.onresize=null
    this.$store.dispatch('removeIntervalObj', 'getPointData')
  },
  mounted() {
    this.overflow()
    this.winWidth = window.innerWidth;
    this.winHeight = window.innerHeight;
    window.onresize = () => {
      return (() => {
        this.winWidth = window.innerWidth;
        this.winHeight = window.innerHeight;
      })();
    };
  },
  methods: {
    getPointData() {
      this.$refs.pointViewDrag.forEach(item => {
        item.getPointValues()
      })
    },
  }
}
</script>

<style scoped>

.listIcon {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: rgba(41, 155, 255, .2);
  text-align: center;
  line-height: 30px;
}

.main {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  padding-bottom: 10px;
}

.vdr.active:before {
  outline: none;
}

</style>
